export enum Page {
  MARCATIONS = 0,
  EDIT_INFORMATIONS = 1,
  TRANSCRIPTION = 2,
  SUMMARY = 3,
  SYNCHRONIZED_TEXT = 4,
  ATA = 5,
}
